import { useEffect, useRef } from "react";
import { usePlayer } from "@/context/PlayerContext";

export const Waveform = ({ playing, bars = 48, className = "" }) => {
  const player = usePlayer();
  const analyserRef = player?.analyserRef;
  const canvasRef = useRef(null);
  const levelsRef = useRef([]);
  const phaseRef = useRef(0);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;
    const g = canvas.getContext("2d");
    levelsRef.current = new Array(bars).fill(0.12);
    let raf = 0;
    const draw = () => {
      raf = requestAnimationFrame(draw);
      const w = (canvas.width = Math.max(2, canvas.clientWidth * 2));
      const h = (canvas.height = Math.max(2, canvas.clientHeight * 2));
      g.clearRect(0, 0, w, h);
      const an = analyserRef?.current;
      let data = null;
      if (an && playing) {
        data = new Uint8Array(an.frequencyBinCount);
        an.getByteFrequencyData(data);
      } else if (playing) {
        phaseRef.current += 0.07;
      }
      const levels = levelsRef.current;
      const step = w / bars;
      const bw = Math.max(2, step - 3);
      for (let i = 0; i < bars; i += 1) {
        let target = 0.12;
        if (data) {
          const idx = Math.floor(Math.pow(i / bars, 1.35) * data.length * 0.72);
          target = 0.12 + (data[idx] / 255) * 0.88;
        } else if (playing) {
          target = 0.3 + 0.22 * Math.abs(Math.sin(phaseRef.current + i * 0.55));
        }
        levels[i] += (target - levels[i]) * 0.35;
        const bh = Math.max(4, levels[i] * h);
        const x = i * step;
        const y = (h - bh) / 2;
        g.fillStyle = `rgba(212, 175, 55, ${(0.35 + levels[i] * 0.65).toFixed(3)})`;
        if (g.roundRect) {
          g.beginPath();
          g.roundRect(x, y, bw, bh, bw / 2);
          g.fill();
        } else {
          g.fillRect(x, y, bw, bh);
        }
      }
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [playing, bars, analyserRef]);

  return <canvas ref={canvasRef} className={className} data-testid="waveform" aria-hidden />;
};
